module.exports = __webpack_public_path__ + "static/media/tooltip-arrow-top.bb303296.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tooltip-arrow-top.svg
// module id = 1083
// module chunks = 0